import React, { useCallback, useContext, useState } from 'react';
import { IEditForm } from '../../types/interfaces/IEditForm';
import { TextField, Typography, Box, IconButton, Button } from '@material-ui/core';
import generatePassword from 'password-generator';
import { SnackMessageContext } from '../../contexts/snackMessage/SnackMessageContext';
import { useTranslation } from 'react-i18next';
import tPaths from '../../utils/tPaths';
import { useHistory, useParams } from 'react-router-dom';
import useApi from '../../utils/useApi';
import { endpoints } from '../../utils/endpoints';

const CodesGenerationField: React.FC<IEditForm> = ({ onChange, value, fieldName, disabled = false }) => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const { push } = useContext(SnackMessageContext);
  const [quantityOfCodes, setQuantityOfCodes] = useState<string>();
  const history = useHistory();
  const { data, post } = useApi<any>(null);

  const handleOnChange = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
      onChange ? onChange(fieldName, event.target.value?.toUpperCase()) : () => null,
    [fieldName, onChange],
  );

  const handleOnClickView = useCallback(() => {
    history.push('/promocodes');
  }, []);

  const handleOnClickGenerate = useCallback(async () => {
    try {
      await post({
        endpoint: `/v1/promoCampaigns/${id}/codes/generate`,
        body: { amount: Number(quantityOfCodes), prefix: value },
        onSuccess: (response) => {
          console.log('response', response);
          push({ title: 'Codes generated!', message: 'Codes were successfully generated' });
        },
      });
    } catch (e) {}
  }, [post, quantityOfCodes, value]);

  return (
    <>
      <Box display="flex" style={{ width: 530, gap: '16px', alignItems: 'flex-end' }}>
        <Box display="flex" flexDirection="column">
          <Typography variant="body2">{t(tPaths.editFormLabels.promoCodePrefix)}</Typography>
          <TextField
            id={fieldName}
            name={fieldName}
            onChange={handleOnChange}
            value={value}
            style={{ width: '80px' }}
          />
        </Box>
        <Box display="flex" flexDirection="column">
          <Typography variant="body2">{t(tPaths.editFormLabels.quantityOfCodes)}</Typography>
          <TextField
            id="quantityOfCodes"
            name="quantityOfCodes"
            onChange={(e) => setQuantityOfCodes(e.target.value)}
            value={quantityOfCodes}
            style={{ width: '100%', maxWidth: '160px' }}
            disabled={disabled}
          />
        </Box>

        <Button color="default" disabled={disabled} onClick={handleOnClickGenerate}>
          Generate codes
        </Button>
        <Button color="default" disabled={disabled} onClick={handleOnClickView}>
          View codes
        </Button>
      </Box>
    </>
  );
};

export default CodesGenerationField;
